import { Phone, MessageCircle } from "lucide-react";
import { CLINIC } from "@/lib/site";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
      <a
        href={CLINIC.whatsapp}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Chat on WhatsApp"
        className="h-12 w-12 rounded-full bg-teal-brand text-alabaster flex items-center justify-center shadow-lg shadow-teal-brand/30 hover:scale-110 active:scale-95 transition-transform duration-200"
      >
        <MessageCircle size={20} />
      </a>
      <a
        href={CLINIC.phoneHref}
        data-testid="floating-call-button"
        aria-label="Call the clinic"
        className="h-12 w-12 rounded-full bg-gold text-teal-obsidian flex items-center justify-center shadow-lg shadow-gold/30 hover:scale-110 active:scale-95 transition-transform duration-200"
      >
        <Phone size={20} />
      </a>
    </div>
  );
}
